<template>
  <div class="made-by-component text--center pb-3">
    <span>
      ©2020. Feito Por
      <a href="https://s1live.com" class="link">S1Live</a>
    </span>
  </div>
</template>

<script>
export default {
  name: 'made-by',
}
</script>

<style lang="scss">
.made-by-component {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
